import {
  APP_NAMESPACE,
  APP_RESOURCES,
  COMMON_NAMESPACE,
  COMMON_RESOURCES,
  TResourceBundles,
} from "@prostocheck/i18n";

/** The dashboard never renders marketing copy, so it does not bundle it. */
export const APP_BUNDLES: TResourceBundles = {
  [COMMON_NAMESPACE]: COMMON_RESOURCES,
  [APP_NAMESPACE]: APP_RESOURCES,
};

export const LOCALE_STORAGE_KEY = "prostocheck.locale";
